(function($) {

    $(document).ready(function() {

        var commentsWrapper = $('.articles-section.comments .comments-wrapper');
        var commentsWrapperSecondary = commentsWrapper.find('.comments-wrapper-secondary');
        var commentsArticles = commentsWrapper.find('.grid-el');
        var authorSelect = $('.article-filter-select[name="article-author"]')[0];
        var dateSelect = $('.article-filter-select[name="article-date"]')[0];
        var resultNotice = commentsWrapper.find('.no-results-notice');

        /*
        *   Page scroll navigation
        */
        $('.article-filter-navigation li').on('click', function() {
            var targetElement = $(this).data('category');
            window.history.replaceState(null, null, '#' + targetElement);

            $([document.documentElement, document.body]).animate({
                scrollTop: $("#"+targetElement).offset().top
            }, 600);
        });


        /*
        *   Select2 and article filtering
        */

        function formatState(elem) {
            var prefix = elem.element.dataset.prefix

            if (prefix) {
                return $(
                    '<span class="prefix">'+prefix+'</span> <span>'+elem.text+'</span>'
                );

            }
            else {
                return elem.text;
            }
        }

        $('.article-filter-select').select2({
            width: 'auto',
            minimumResultsForSearch: -1,
            templateSelection: formatState
        });

        $('.article-filter-select').on('change', function(e) {
            var author = authorSelect.value;
            var year = dateSelect.value;
            var filteredArticles;

            if (year !== 'all' && author !== 'all') {
                filteredArticles = commentsArticles.filter('[data-year="'+year+'"][data-author="'+author+'"]');
            }
            else if (year === 'all' && author !== 'all') {
                filteredArticles = commentsArticles.filter('[data-author="'+author+'"]');
            }
            else if (author === 'all' && year !== 'all') {
                filteredArticles = commentsArticles.filter('[data-year="'+year+'"]');
            }
            else if (year === 'all' && author === 'all') {
                filteredArticles = commentsArticles.filter('[data-year][data-author]');
            }

            commentsWrapper.css({'transition': '0.5s ease-in-out'});
            commentsWrapper.addClass('hidden');

            setTimeout(function() {
                commentsWrapper.css({'height': commentsWrapperSecondary.outerHeight(), 'transition': 'none'});
                commentsArticles.addClass('hidden');

                if (filteredArticles.length) {
                    filteredArticles.removeClass('hidden');
                    resultNotice.removeClass('active');
                } else {
                    resultNotice.addClass('active');
                }

                if (commentsWrapper.outerHeight() !== commentsWrapperSecondary.outerHeight()) {
                    commentsWrapper.animate({'height': commentsWrapperSecondary.outerHeight()}, 300, function () {
                        setTimeout(function () {
                            commentsWrapper.css({'transition': '0.5s ease-in-out'});
                            commentsWrapper.removeClass('hidden');
                        }, 250);
                    });
                } else {
                    setTimeout(function() {
                        commentsWrapper.css({'transition': '0.5s ease-in-out'});
                        commentsWrapper.removeClass('hidden');
                    }, 250);
                }
            }, 500);

        });
    });

})( jQuery );